<template>
  <nav>
    <div class="fill-height">
      <v-row
        class="fill-height"
        align="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          offset-sm="2"
          offset-md="3"
          align="center"
        >
          <v-img
            :src="require('../../assets/image3.png')"
            width="100%"
            max-width="400px"
            class="mx-auto mb-10"
            @load="loadingImage = false"
          />
          <p
            v-if="!loadingImage"
            class="text-h4 font-weight-bold"
          >
            {{ $t('pageMaintenanceModeTitle') }}
          </p>
          <p
            v-if="!loadingImage"
            class="text-body-1 greytext--text"
          >
            {{ $t('pageMaintenanceModeText') }}
          </p>
        </v-col>
      </v-row>
    </div>
  </nav>
</template>
<script>

export default {
    data(){
        return{
            loadingImage: true
        }
    }
}
</script>
